import { Platform } from 'react-native';
import AppManifest from './AppManifest';

const DSN =
  'https://a20df13274948d23050373931765388a@o4509810594545664.ingest.us.sentry.io/4509833321054208';

const env = AppManifest.env || 'development';

// Guard the @sentry/react-native import: older native binaries shipped before
// the SDK was linked will throw at module evaluation if we use a static import,
// which (under React 19's strict lazy resolver) becomes a fatal crash.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let Sentry: any;
try {
  Sentry = require('@sentry/react-native');
} catch (error) {
  console.warn('Sentry native module unavailable; instrumentation disabled', error);
  Sentry = null;
}

export const routingInstrumentation = Sentry
  ? Sentry.reactNavigationIntegration()
  : undefined;

if (Sentry && env !== 'development') {
  try {
    Sentry.init({
      dsn: DSN,
      environment: env,
      release: `chloe-app@${AppManifest.version}+${AppManifest.buildNumber}`,
      dist: String(AppManifest.buildNumber),
      enabled: true,
      tracesSampleRate: env === 'production' ? 0.2 : 1.0,
      sendDefaultPii: false,
      integrations: [
        routingInstrumentation,
        Sentry.breadcrumbsIntegration({
          console: true,
          fetch: true,
          xhr: true
        })
      ],
      enableAutoSessionTracking: true,
      attachStacktrace: true,
      beforeBreadcrumb(breadcrumb: any) {
        if (breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') {
          const url = breadcrumb.data?.url || '';
          if (typeof url === 'string' && url.includes('/api/')) {
            return breadcrumb;
          }
          return null;
        }
        return breadcrumb;
      },
      beforeSend(event: any) {
        if (Platform.OS === 'web') {
          return null;
        }
        return event;
      }
    });
  } catch (error) {
    console.warn('Sentry.init failed', error);
  }
}

export function setSentryUser(user: { id: number }) {
  if (!Sentry) return;
  try {
    Sentry.setUser({ id: String(user.id) });
  } catch (error) {
    console.warn('Sentry.setUser failed', error);
  }
}

export function clearSentryUser() {
  if (!Sentry) return;
  try {
    Sentry.setUser(null);
  } catch (error) {
    console.warn('Sentry.setUser failed', error);
  }
}

export default Sentry;
